import proImage from "assets/image/book_dflt_prd_item.png";
import { useRef } from "react";

type IProps = {
  src: string;
  alt?: string;
};

export default function ImageComponent({ src, alt = "이미지" }: IProps) {
  const imgRef = useRef(null);

  return (
    <>
      <img
        ref={imgRef}
        src={src || proImage}
        alt={alt}
        decoding="async"
        loading="lazy"
        onError={(e) => {
          if (e.type === "error") {
            e.currentTarget.src = proImage;
          }
        }}
      />
    </>
  );
}
